import { render, staticRenderFns } from "./salesDiscount.vue?vue&type=template&id=0e74c278"
import script from "./salesDiscount.vue?vue&type=script&lang=js"
export * from "./salesDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports